<template>
 <div>
   <div class="row">
     <div class="common-print-action-buttons">


       <button
           class="d-none d-sm-inline-block btn btn-sm btn-info shadow-sm"
           @click="exportToPDFText()"

       >
         <i class="fas fa-download"/>
         Eksportuj do PDF
       </button>


     </div>



 </div>

  <div class="common-print-order">
    <h1 class="document-title"></h1>
    <div class="document-details">
      <div v-for="[key,value] of Object.entries(this.objectToPrint)" :key="key">
        <p><strong>{{ key }}: </strong> {{ value || '---' }}</p>

      </div>
    </div>
  </div>
 </div>
</template>

<script>

import jsPDF from "jspdf";
import {jsFonts} from "./data/jsFonts";

export default {
  name: "CommonObjectSimplePrintPage",
  props: {
    objectToPrint: {
      type: Object,
      required: true
    },
    title:{
      type: String,
      required: true
    }
  },
  methods: {
    exportToPDFText() {

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: "a4"
      });
      // Adding the font which supports Polish characters
      var arialNormalFont = jsFonts.ArialNormalJs;
      pdf.addFileToVFS('arial-normal.ttf', arialNormalFont);
      pdf.addFont('arial-normal.ttf', 'arial', 'normal');
      pdf.setFont("arial");

      // Add title
      pdf.setFontSize(16);

      pdf.text(this.title, 40, 40);


      // Add document details
      var beginningY = 60;
      var currentY = beginningY;
      for(const [key, value] of Object.entries(this.objectToPrint)){
        pdf.setFontSize(12);
        pdf.text(`${key}: ${value || '---'}`, 40, currentY);
        currentY += 20;
      }

      // Save the PDF
      pdf.save(`${this.title}_${this.generateRandomUUID()}.pdf`);
    },

    generateRandomUUID() {
      return Math.random().toString(36).substring(2) + Date.now().toString(36);
    },

    breakTextAfterEveryNChars(text, n) {
      if (text === null) return null;
      return text.match(new RegExp('.{1,' + n + '}', 'g')).join('\n');
    },

    formatDate(date) {
      if (!date) return null;
      return new Date(date).toLocaleDateString();
    },
    formatCurrency(value) {
      if (value === null) return null;
      return Number(value).toFixed(2);
    }
  }
};
</script>

<style scoped>

.common-print-action-buttons {
  text-align: right;
  margin-right: 4px;
  margin-bottom: 16px;
  margin-top:16px;
}

.common-print-order {
  font-family: Arial, sans-serif;
  width: 748px;
  border: 1px solid #ccc;
  padding: 20px;
  margin: 20px auto;
  background-color: #f9f9f9;
}

.document-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.document-details {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.document-info, .party-info, .payment-info {
  border-top: 1px solid #ddd;
  padding-top: 10px;
}

h2 {
  font-size: 18px;
  margin-bottom: 10px;
}

p {
  margin: 5px 0;
  font-size: 14px;
}

strong {
  font-weight: bold;
}
</style>
